import React, { useState, useCallback, useEffect } from "react";
import {
  Card,
  CardHeader,
  CardBody,
  Container,
  Row,
  Col,
  Form,
  FormGroup,
  Input,
  Button,
  Table,
  Label,
} from "reactstrap";

// API
import Dataservices from "../../services/requestApi";

// Header
import Header from "components/Headers/Header";

// antd
import { message } from "antd";

const ReferAndEarn = () => {
  const [allRank, setAllRank] = useState([]);
  const [ready, setReady] = useState(false);
  const [isEdit, setIsEdit] = useState(false);

  const [formData, setFormData] = useState({
    rank: "",
    discount: "",
    points: "",
  });

  // ================= GET ALL RANK =================
  const getAllRank = useCallback(async () => {
    try {
      setReady(true);
      const res = await Dataservices.getAllRank();
      setAllRank(res?.data?.Admin || []);
      setReady(false);
    } catch (error) {
      console.log(error);
      setReady(false);
    }
  }, []);

  useEffect(() => {
    getAllRank();
  }, [getAllRank]);

  // ================= ON RANK CHANGE =================
  const handleRankChange = (e) => {
    const selectedId = e.target.value;
    const rankData = allRank.find((r) => r._id === selectedId);

    setFormData({
      rank: selectedId,
      discount: rankData?.refer_discount ?? rankData?.ediscount ?? 0,
      points: rankData?.refer_coin ?? 0,
    });

    setIsEdit(true);
  };

  // ================= INPUT CHANGE =================
  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  // ================= EDIT FROM TABLE =================
  const handleEdit = (item) => {
    setFormData({
      rank: item._id,
      discount: item.refer_discount ?? item.ediscount ?? 0,
      points: item.refer_coin ?? 0,
    });

    setIsEdit(true);
  };

  // ================= SUBMIT =================
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.rank) {
      message.warning("Please select rank");
      return;
    }

    // const payload = {
    //   refer_coin: Number(formData.points),
    //   refer_discount: Number(formData.discount),
    // };

      const data = new FormData();
      data.append('refer_coin',formData.points);
      data.append('refer_discount',formData.discount);

    console.log(data,'payload');
    
    try {
      setReady(true);
      await Dataservices.updateReferAndEarn(data, formData.rank);

      message.success("Refer & Earn updated successfully");

      // refresh table
      await getAllRank();

      // reset form
      setFormData({
        rank: "",
        discount: "",
        points: "",
      });

      setIsEdit(false);
      setReady(false);
    } catch (error) {
      console.log(error);
      setReady(false);
      message.error("Update failed");
    }
  };

  return (
    <>
      <Header show={false} />

      <Container className="mt--7" fluid>
        <Row>
          <Col xl="12">
            <Card className="shadow mt-5">
              {/* HEADER */}
              <CardHeader className="bg-white border-0">
                <Row className="align-items-center">
                  <Col>
                    <h3 className="mb-0">Refer & Earn</h3>
                  </Col>
                </Row>
              </CardHeader>

              {/* BODY */}
              <CardBody>
                {/* FORM */}
                <Form onSubmit={handleSubmit}>
                  <Row>
                    <Col md="4">
                      <FormGroup>
                        <Label>Distributor Rank</Label>
                        <Input
                          type="select"
                          name="rank"
                          value={formData.rank}
                          onChange={handleRankChange}
                          disabled={isEdit}
                        >
                          <option value="">Select Rank</option>
                          {allRank.map((item) => (
                            <option key={item._id} value={item._id}>
                              {item.name}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>
                    </Col>

                    <Col md="4">
                      <FormGroup>
                        <Label>Discount (%)</Label>
                        <Input
                          type="number"
                          name="discount"
                          value={formData.discount}
                          onChange={handleChange}
                        />
                      </FormGroup>
                    </Col>

                    <Col md="4">
                      <FormGroup>
                        <Label>Points / ShopperCoins</Label>
                        <Input
                          type="number"
                          name="points"
                          value={formData.points}
                          onChange={handleChange}
                        />
                      </FormGroup>
                    </Col>
                  </Row>

                  <Button color="primary" type="submit" disabled={ready}>
                    {ready ? "Updating..." : "Update"}
                  </Button>

                  {isEdit && (
                    <Button
                      color="secondary"
                      className="ml-2"
                      onClick={() => {
                        setFormData({
                          rank: "",
                          discount: "",
                          points: "",
                        });
                        setIsEdit(false);
                      }}
                    >
                      Cancel
                    </Button>
                  )}
                </Form>

                {/* LISTING */}
                {allRank.length > 0 && (
                  <Table className="mt-4" bordered responsive>
                    <thead className="thead-light">
                      <tr>
                        <th>#</th>
                        <th>Rank Name</th>
                        <th>Discount (%)</th>
                        <th>Points</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {allRank.map((item, index) => (
                        <tr key={item._id}>
                          <td>{index + 1}</td>
                          <td>{item.name}</td>
                          <td>
                            {item.refer_discount ??0}
                          </td>
                          <td>{item.refer_coin ?? 0}</td>
                          <td>
                            <Button
                              size="sm"
                              color="info"
                              onClick={() => handleEdit(item)}
                            >
                              <i className="ni ni-ruler-pencil" />
                            </Button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                )}
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default ReferAndEarn;
